import { render, staticRenderFns } from "./SellersTable.vue?vue&type=template&id=496a19ac"
import script from "./SellersTable.vue?vue&type=script&lang=js"
export * from "./SellersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports